import { EventEmitter, Injectable } from '@angular/core';

import { Optional } from '@core/models/global-entities/global-entities';
import { HubConnection } from '@microsoft/signalr';
import { ApiService } from './api.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class BaseSignalrService extends BaseService {
  protected _hubConnection: HubConnection;
  protected _connectionTimeout;
  connectionEstablished = new EventEmitter<boolean>();
  isConnectionEstablished = false;

  constructor(public apiService: ApiService) {
    super();
  }

  /** Extend Implementation */

  protected getAuthToken(): string {
    return '';
  }

  protected createConnection() {}

  protected registerUser() {}

  protected onServerEventsRegister() {}

  protected reconnectPolicy(context) {
    console.log('Reconnecting context:', context);
    // try to reconnect after every 10s
    return 10 * 1000;
  }

  /** Public interface */

  init() {
    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();
  }

  disconnect(): Optional<Promise<void>> {
    if (this._connectionTimeout) {
      clearTimeout(this._connectionTimeout);
      this._connectionTimeout = null;
    }
    return this._hubConnection?.stop();
  }

  /** Private Implementation */

  private startConnection() {
    if (this._hubConnection === undefined || this._hubConnection == null) {
      this.createConnection();
    }

    this._hubConnection.start().then(
      () => this.onConnection(),
      (err) => this.onConnectionClose(err)
    );
  }

  private registerOnServerEvents() {
    if (!this._hubConnection) {
      return;
    }
    this._hubConnection.onreconnected((connectionId) =>
      this.onConnectionReconnected(connectionId)
    );
    this._hubConnection.onreconnecting((e) => this.onConnectionReconnecting(e));
    this._hubConnection.onclose((e) => this.onConnectionClose(e));
    this.connectionEstablished.subscribe((data) => data && this.registerUser());
    this.onServerEventsRegister();
  }

  private onConnection() {
    this.isConnectionEstablished = true;
    this.publishConnectionStatus();
  }

  private onConnectionClose(err: Optional<Error>) {
    console.log('ConnectionClose:');
    console.error(err);
    this.isConnectionEstablished = false;
    this.publishConnectionStatus();
    if (err) {
      console.log('Manual Reconnect in 5s');
      this._connectionTimeout = setTimeout(() => {
        this.startConnection();
      }, 5000);
    }
  }

  private onConnectionReconnecting(err?: Error) {
    console.log('ConnectionReconnecting:');
    console.error(err);
    this.isConnectionEstablished = false;
    this.publishConnectionStatus();
  }

  private onConnectionReconnected(connectionId: string) {
    console.log('ConnectionReconnected:', connectionId);
    this.isConnectionEstablished = true;
    this.publishConnectionStatus();
  }

  private publishConnectionStatus(status = this.isConnectionEstablished) {
    this.connectionEstablished.emit(status);
  }
}
